import { Tabs } from "antd";
import React from "react";
import MdTab from "./page";
import EmployeeBlackListTab from "./Employee";
import AdvanceBlackListTab from "./Advance";

type Props = {
  permissions: Record<string, boolean>;
};

const MdTabs = ({ permissions }: Props) => {
  const items = [
    {
      key: "md",
      label: "MD",
      children: <MdTab permissions={permissions} />,
    },
    {
      key: "employee-black-list",
      label: "Employee black list",
      children: <EmployeeBlackListTab permissions={permissions} />,
    },
    {
      key: "advance-black-list",
      label: "Avans olishni rad etganlar",
      children: <AdvanceBlackListTab permissions={permissions} />,
    },
  ];

  return <Tabs items={items} />;
};

export default MdTabs;
